import { useEffect } from 'react';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import BaseSwipeableDrawer from '../../../../common/BaseSwipeableDrawer/BaseSwipeableDrawer';
import EditTimesheetFormFullMonth from './component/EditTimesheetFormFullMonth';
import colors from '../../../../../scss/colors';
import classes from './EditMonthlyTimesheetDrawer.module.scss';
import MainButton from '../../../../common/buttons/MainButton';
import { ApproverSelectionComponent } from '../ApproverSelectionComponent/ApproverSelectionComponent';

const StyledSwiper = styled('div')(() => ({
  width: '50px',
  height: '8px',
  backgroundColor: colors.LIGHT_GREY,
  borderRadius: '10px'
}));

const EditMonthlyTimesheetDrawer = ({
  data,
  saveHandler,
  closeHandler,
  allowedWorkTypes,
  rateType,
  deleteLineHandler,
  currentMonth,
  placementStatus,
  placementHandler,
  timesheetType,
  isSplitApprovalFlow,
  approverSelectionProps
}) => {
  const { t } = useTranslation();

  const timesheetForm = useFormik({
    initialValues: data?.timesheet
  });

  useEffect(() => {
    if (placementStatus && timesheetForm.dirty) {
      placementHandler();
    }
  }, [timesheetForm.dirty]);

  const { openSection, approver, setOpenPop, setApprover, changeHandler, approvers } = approverSelectionProps;

  return (
    <BaseSwipeableDrawer closeHandler={closeHandler}>
      <StyledSwiper />
      <div className={classes.mainContainer}>
        <div className={classes.auxContainer}>
          {isSplitApprovalFlow && (
            <div className="flex flex-col w-full gap-2 mb-3">
              <p className="text-navy-blue">{t('common.forms.approver')}*</p>
              <ApproverSelectionComponent
                t={t}
                section={openSection}
                approver={approver}
                setOpenPop={setOpenPop}
                setApprover={setApprover}
                changeHandler={changeHandler}
                approvers={approvers}
              />
            </div>
          )}
        </div>
        <EditTimesheetFormFullMonth
          isComplexWorktype
          formData={timesheetForm}
          allowedWorkTypes={allowedWorkTypes}
          rateType={rateType}
          choosedMonth={currentMonth}
          timesheetType={timesheetType}
        />
      </div>
      <div className={classes.actionsContainer}>
        <MainButton
          size="small"
          variant="disabled"
          outlined
          rounded
          action={() => {
            deleteLineHandler(data.timesheet.Id);
            closeHandler();
          }}
          forceWidth="100%"
        >
          {t('common.general.delete')}
        </MainButton>
        <MainButton
          size="small"
          variant={!timesheetForm.dirty || placementStatus ? 'disabled' : 'primary'}
          outlined={false}
          rounded
          disabled={!timesheetForm.dirty}
          action={placementStatus ? placementHandler : () => saveHandler(timesheetForm.values)}
          forceWidth="100%"
        >
          {t('common.general.save')}
        </MainButton>
      </div>
    </BaseSwipeableDrawer>
  );
};

export default EditMonthlyTimesheetDrawer;
